export default {"src":"/_next/static/media/app-store-Store.b32be7bb.svg","height":40,"width":135,"blurWidth":0,"blurHeight":0};